<div class="mk-card ufg" [class.done]="group.answered">
  <ng-container *ngIf="single as item; else grouped">
    <b class="ufg-title">{{ item.name }}</b>
    <div class="mk-muted">
      <ng-container *ngIf="item.code">{{ item.code }} &middot; </ng-container>
      <ng-container *ngIf="group.sageUnit; else noSageUnit">Sage unit <b>"{{ group.sageUnit }}"</b></ng-container>
      <ng-template #noSageUnit>Sage has no unit for this item</ng-template>
    </div>
    <div class="field">
      <label [for]="fieldId('unit', item.matchId)">Unit in Aivor</label>
      <select
        #rowSelect
        [id]="fieldId('unit', item.matchId)"
        [attr.data-match-id]="item.matchId"
        [disabled]="saving"
        (change)="onRowSelect(item, $any($event.target).value)"
      >
        <option value="" disabled>Choose a unit&hellip;</option>
        <option *ngFor="let unit of units" [value]="unit.id">{{ unit.name }} ({{ unit.code }})</option>
      </select>
    </div>
    <p class="ufg-reason" *ngIf="item.reason">
      <i class="bi bi-exclamation-triangle-fill" aria-hidden="true"></i><span>{{ item.reason }}</span>
    </p>
  </ng-container>

  <ng-template #grouped>
    <b class="ufg-title">{{ title }}</b>
    <div class="mk-muted" [ngSwitch]="group.kind">
      <ng-container *ngSwitchCase="'suggested'">
        <ng-container *ngIf="example as item">
          We found the unit in {{ count === 1 ? 'its name' : 'each name, for example' }}
          "<ng-container *ngFor="let part of parts(item)"><mark *ngIf="part.found">{{ part.text }}</mark><ng-container *ngIf="!part.found">{{ part.text }}</ng-container></ng-container>".
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'sage-unit'">Aivor doesn't have this unit. Choose one for all of them.</ng-container>
      <ng-container *ngSwitchDefault>
        Choose one Aivor unit for all of them. They may not all be measured the same way, so check the list and change any that differ.
      </ng-container>
    </div>

    <div class="field">
      <label [for]="fieldId('unit-group')">{{ fieldLabel }}</label>
      <select #groupSelect [id]="fieldId('unit-group')" [disabled]="saving" (change)="onGroupSelect($any($event.target).value)">
        <option value="" disabled>Choose a unit&hellip;</option>
        <option *ngFor="let unit of units" [value]="unit.id">{{ unit.name }} ({{ unit.code }})</option>
      </select>
    </div>
    <button type="button" class="btn-teal-gradient ufg-use" *ngIf="useLabel" [disabled]="saving" (click)="use()">{{ useLabel }}</button>

    <p class="ufg-note ufg-all-own" role="status" *ngIf="allOwnShown">
      <i class="bi bi-info-circle" aria-hidden="true"></i><span>{{ allOwnNote }}</span>
    </p>

    <p class="ufg-note" *ngIf="quantityNote as note">
      <i class="bi bi-info-circle" aria-hidden="true"></i><span>{{ note }}</span>
    </p>

    <div class="ufg-status" *ngIf="status" [class.ok]="group.answered">
      <i class="bi bi-check-lg" *ngIf="group.answered" aria-hidden="true"></i><span>{{ status }}</span>
    </div>

    <button type="button" class="link-btn" [attr.aria-expanded]="open" [attr.aria-controls]="fieldId('unit-list')" (click)="toggle()">
      Choose for each item ({{ count }}) <i class="bi bi-chevron-down ufg-chev" [class.up]="open" aria-hidden="true"></i>
    </button>

    <div class="ufg-list" *ngIf="open" [id]="fieldId('unit-list')">
      <div class="ufg-search">
        <i class="bi bi-search" aria-hidden="true"></i>
        <input
          type="search"
          [id]="fieldId('unit-search')"
          [value]="query"
          placeholder="Search by name or code"
          [attr.aria-label]="'Search these ' + count + ' items'"
          autocomplete="off"
          (input)="onSearch($any($event.target).value)"
        />
      </div>

      <p class="mk-muted ufg-none" *ngIf="!filtered.length">No items match "{{ query.trim() }}".</p>

      <ng-container *ngIf="filtered.length">
        <ul class="ufg-rows">
          <li class="ufg-row" *ngFor="let item of shownRows; trackBy: trackItem">
            <div class="ufg-name">
              <b><ng-container *ngFor="let part of parts(item)"><mark *ngIf="part.found">{{ part.text }}</mark><ng-container *ngIf="!part.found">{{ part.text }}</ng-container></ng-container></b>
              <span class="mk-muted">{{ item.code }}<ng-container *ngIf="ownUnit(item)"> · <span class="ufg-own">own unit</span></ng-container></span>
              <span class="ufg-reason" *ngIf="item.reason">{{ item.reason }}</span>
            </div>
            <select
              #rowSelect
              class="ufg-row-select"
              [id]="fieldId('unit-row', item.matchId)"
              [attr.data-match-id]="item.matchId"
              [attr.aria-label]="'Unit in Aivor for ' + item.name"
              [disabled]="saving"
              (change)="onRowSelect(item, $any($event.target).value)"
            >
              <option value="" disabled>Choose a unit&hellip;</option>
              <option *ngFor="let unit of units" [value]="unit.id">{{ unit.name }} ({{ unit.code }})</option>
            </select>
          </li>
        </ul>
        <div class="ufg-more">
          <span class="mk-muted">Showing {{ shownRows.length }} of {{ filtered.length }}{{ query.trim() ? ' that match' : '' }}.</span>
          <button type="button" class="link-btn" *ngIf="moreCount > 0" (click)="showMore()">Show {{ moreCount }} more</button>
        </div>
      </ng-container>
    </div>
  </ng-template>
</div>
